import React, { useCallback } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { getAuthorizationHeader } from '../../../utils/auth';
import { fetchRequest } from '../../../utils/fetchRequest';
import Row from '../../Structure/Row';
import Group from '../../Structure/Group';
import Button from '../../Button';

const DeleteMassModalConstructor = (props) => {
  const {
    hideModal,

    DELETE_REQUEST_URL,
    DELETE_STATIC_HINT,
    DELETE_STATIC_VALUE,
  } = props;

  const deleteProperty = useCallback(() => {
    const fetchDelete = async () => {
      const options = {
        method: 'POST',
        headers: {
          'Authorization': getAuthorizationHeader(),
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          ids: DELETE_STATIC_VALUE,
        }),
      };

      const url = DELETE_REQUEST_URL;
      const { success } = await fetchRequest(url, options);

      if (success) {
        window.location.reload();
      }
    };

    fetchDelete();
  }, [DELETE_REQUEST_URL]);

  return (
    <ConfirmDeleteContainer>
      <Row>
        {DELETE_STATIC_HINT}
      </Row>
      <Group align='right'>
        <Button label='Отмена' theme='hollow' onClick={hideModal} />
        <Button label='Удалить' color='alert' onClick={deleteProperty} />
      </Group>
    </ConfirmDeleteContainer>
  );
};

const ConfirmDeleteContainer = styled.div`
  ${({ theme }) => theme.mixins.gothamRegular()};
  font-size: ${({ theme }) => theme.fonts.sizes[theme.userSettings.fontSize]};
`

const ContextName = styled.span`
  ${({ theme }) => theme.mixins.gothamSemibold()};
  font-size: ${({ theme }) => theme.fonts.sizes[theme.userSettings.fontSize]};
`

DeleteMassModalConstructor.propTypes = {
  hideModal: PropTypes.func.isRequired,
};

export default DeleteMassModalConstructor;